import { AppLink } from '@common/components/Link/AppLink';
import { useSelectedCollectionMetadata } from '@features/metadata';
import { Flex, Skeleton, Text } from '@radix-ui/themes';
import { createCollectionDetailsPagePath } from '@router';

export const ProgramLink = () => {
    const { data: metadata, isLoading } = useSelectedCollectionMetadata();

    const { title, collectionId } = metadata;

    return (
        <Text>
            <Skeleton loading={isLoading}>
                <AppLink
                    to={createCollectionDetailsPagePath(collectionId)}
                    style={{ textDecoration: 'underline' }}
                >
                    <Flex align={'center'} gap={'2'}>
                        {/* <Trans
                            i18nKey={'clipDetails:programPage'}
                            values={{ title }}
                        /> */}
                        {title}
                    </Flex>
                </AppLink>
            </Skeleton>
        </Text>
    );
};
